// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
};

const CancelTransfer = (props: Props) => {
  const {
    visible,
    close,
    submit,
  } = props;

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={() => submit()} type="danger">Confirm Cancellation</SpButton>,
      ]}
      title="Confirmation"
    >
      <div className="px-4">
        <div className="pb-3">
          This cancellation may void your debited funds.
          If the bank has already debited the amount from your account, the funds will be refunded within 3–5 business days.
        </div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default CancelTransfer;
